import React from 'react';
import { Chevron } from '@/resources/assets/images';
import { SelectedListItem, useSearchTabContext } from './SearchTabContext';
import ClearFiltersButton from '../ClearFiltersButton/ClearFiltersButton';

interface Props {
	filterName: SelectedListItem;
	filterCount: number;
	onClick: () => void;
	displayClearFiltersButton: boolean;
	icon: React.ReactElement<SVGSVGElement>;
}

const SearchTabFiltersListItemHeader = ({
	filterName,
	filterCount,
	onClick,
	displayClearFiltersButton,
	icon
}: Props) => {
	const { selectedListItem, setSelectedListItem } = useSearchTabContext();

	return (
		<div
			className="search-tab-filters-list-item-header"
			onClick={() =>
				setSelectedListItem(
					selectedListItem === filterName ? '' : filterName
				)
			}
		>
			<span className="search-tab-filter-list-item-inner">
				{icon}
				{filterName}
			</span>
			<span className="search-tab-filter-list-item-icons">
				{displayClearFiltersButton && (
					<ClearFiltersButton
						filterCount={filterCount}
						onClick={onClick}
					/>
				)}
				<Chevron className="search-tab-filter-list-item-chevron" />
			</span>
		</div>
	);
};

export default SearchTabFiltersListItemHeader;
